import { Link } from '@tanstack/react-router';

import { Button } from '@/shared/ui/button';
import { Result } from '@/shared/ui/result';

export function NotFound() {
  return (
    <Result
      title='찾는 화면이 없어요'
      actions={
        <Button asChild size='l'>
          <Link to='/'>홈으로 가기</Link>
        </Button>
      }
    />
  );
}
